import { render } from "./request-support.vue?vue&type=template&id=3b05b912&ts=true"
import script from "./request-support.vue?vue&type=script&lang=ts"
export * from "./request-support.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__